/*
Author : Raphaël Dardeau


Markup :

<div class="diaporama js-diapo">
    <div class="diaporama__focus js-diapo-focus">
        <div class="diaporama__image"></div>
        <div class="diaporama__caption"></div>
    </div>
    <div class="diaporama__nav js-diapo-hscroll">
        <a href="#" class="diaporama__arrow diaporama__arrow--left js-diapo-hscroll-left"><span class="diaporama__arrowIcon"></span></a>
        <a href="#" class="diaporama__arrow diaporama__arrow--right js-diapo-hscroll-right"><span class="diaporama__arrowIcon"></span></a>
        <div class="diaporama__scene js-diapo-hscroll-mask">
            <ul class="diaporama__thumbs js-diapo-hscroll-list">
                <li class="diaporama__thumb js-diapo-item">
                    <a href="#1">
                        <img src="http://medias.lequipe.fr/img-photo-jpg/eusebio-ferreira/1500000000475515/97:319,1644:1337-134-86-75/193b2.jpg" data-fullsrc="http://medias.lequipe.fr/img-photo-jpg/eusebio-ferreira/1500000000475515/97:319,1644:1337-966-635-75/95849.jpg" alt="" title="3 mars 1973. France-Portugal : 1-2." />
                        <span class="diaporama__thumbDesc">Les Bleus de Marius Trésor accueillent le Portugal d'Eusebio en amical au Parc des Princes. Malgré l'ouverture du score de Molitor, l'équipe de France s'incline après un doublé de la "panthère noire". (L'Equipe)</span>
                    </a>
                </li>
                <li class="diaporama__thumb js-diapo-item">
                    <a href="#2">
                        <img src="http://medias.lequipe.fr/img-photo-jpg/charrier-rene-tresor-marius-nene-tamagnini/1500000000475516/73:26,2048:1325-134-86-75/e672e.jpg" data-fullsrc="http://medias.lequipe.fr/img-photo-jpg/charrier-rene-tresor-marius-nene-tamagnini/1500000000475516/73:26,2048:1325-966-635-75/ae5d8.jpg" alt="" title="26 avril 1975. France-Portugal : 0-2." />
                        <span class="diaporama__thumbDesc">L'équipe de France défie à nouveau le Portugal en amical, cette fois à Colombes. Les Bleus s'inclinent suite à des buts de Nene (en photo) et Marinho. (L'Equipe)</span>
                    </a>
                </li>
                <li class="diaporama__thumb js-diapo-item">
                    <a href="#3">
                        <img src="http://medias.lequipe.fr/img-photo-jpg/baronchelli-bruno/1500000000475533/138:196,1913:1363-134-86-75/9af5e.jpg" data-fullsrc="http://medias.lequipe.fr/img-photo-jpg/baronchelli-bruno/1500000000475533/138:196,1913:1363-966-635-75/e53df.jpg" alt="" title="8 mars 1978. France-Portugal : 2-0." />
                        <span class="diaporama__thumbDesc">Toujours en amical, au Parc des Princes, les Bleus de Didier Six, Alain Giresse ou encore Maxime Bossis dominent cette fois le Portugal. Bruno Baronchelli (en photo) ouvre la marque d'une sublime volée avant que Marc Berdoll ne double la mise. (L'Equipe)</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>


Setup :

$(function() {
    $(".js-diapo").diapo();
});
*/
;(function ($, window, document, undefined) {
    "use strict";

    var pluginName = "diapo",
        defaults = {
            tabElements: ".js-diapo-item",
            tabContentElements: ".js-diapo-content",
            tabContentBloc: ".js-diapo-container",
            tabActiveClass: "is-active",
            container: ".js-diapo-hscroll-mask",
            scroller: ".js-diapo-hscroll-list",
            controllerLeft: ".js-diapo-hscroll-left",
            controllerRight: ".js-diapo-hscroll-right",
            autoTab: true,
            imageRatio: 1.52126
        };

    function Plugin (element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        $(window).on("resize", $.proxy(function() {
            this.screenWidth = $(window).width();
            this.init();
        }, this));
        $(window).trigger("resize");
    }

    $.extend(Plugin.prototype, {
        init: function () {
            this.setElements();
            this.unsetEvents();
            this.unsetDefaultStyles();
            this.setVars();
            this.setDefaultStyles();
            this.maxItemIndex = this.getMaxItemIndex();
            this.toCenter();
            this.setControllers();
            this.setEvents();

            if (this.$tabs.filter("."+ this.settings.tabActiveClass).length)
                this.$tabs.filter("."+ this.settings.tabActiveClass).removeClass(this.settings.tabActiveClass).trigger("click");
            else
                this.$tabs.first().trigger("click");
        },
        setElements: function() {
            this.$element = $(this.element);
            this.$container = this.$element.find(this.settings.container);
            this.$scroller = this.$element.find(this.settings.scroller);
            this.$items = this.$scroller.children();
            this.setActiveItem();
            this.$left = this.$element.find(this.settings.controllerLeft);
            this.$right = this.$element.find(this.settings.controllerRight);

            this.$tabs = this.$element.find(this.settings.tabElements);
            this.$tabsContent = this.$element.find(this.settings.tabContentElements);
            this.$tabsContentBloc = this.$element.find(this.settings.tabContentBloc);
        },
        setActiveItem: function() {
            this.$activeItem = this.$items.filter(".is-active");
            this.activeItemIndex = this.$items.index(this.$activeItem);
        },
        setVars: function() {
            this.scrollerHeight = this.$items.filter(":first").outerHeight();
            var scrollerWidth = 0;
            this.$items.each(function() {
                scrollerWidth += $(this).outerWidth(true);
            });
            this.scrollerWidth = scrollerWidth;
            this.visibleWidth = this.$container.width();
            this.itemNum = this.$items.length;
            this.currentItemIndex = 0;

            this.tplDiapoFocus = $("#tpl-diapo-focus").html();
            Mustache.parse(this.tplDiapoFocus);
        },
        getMaxItemIndex: function() {
            var plugin = this;
            var maxItemIndex = this.itemNum - 1;
            $(this.$items.get().reverse()).each(function() {
                if ($(this).position().left >= plugin.scrollerWidth - plugin.visibleWidth)
                    maxItemIndex = $(this).index();
            });
            return maxItemIndex;
        },
        setDefaultStyles: function() {
            this.$container.css({
                position:"relative"
            });
            this.$scroller.css({
                position:"absolute",
                left:0,
                width:this.scrollerWidth
            });
            this.$tabsContentBloc.css({
                minHeight:(this.$tabsContentBloc.outerWidth() / this.settings.imageRatio )
            });
        },
        unsetDefaultStyles: function() {
            this.$container.removeAttr("style");
            this.$scroller.removeAttr("style");
            this.$tabsContentBloc.removeAttr("style");
            this.$element.removeAttr("is-loaded");
        },
        setControllers: function() {
            if (!this.settings.autoTab) {
                if (this.currentItemIndex === 0)
                    this.$left.addClass("is-disabled");
                else if (this.$left.hasClass("is-disabled"))
                    this.$left.removeClass("is-disabled");
                if (this.currentItemIndex >= this.maxItemIndex)
                    this.$right.addClass("is-disabled");
                else if (this.$right.hasClass("is-disabled"))
                    this.$right.removeClass("is-disabled");
            } else {
                if (!this.activeItemIndex)
                    this.$left.addClass("is-disabled");
                else if (this.$left.hasClass("is-disabled"))
                    this.$left.removeClass("is-disabled");
                if (!this.$items.eq(this.activeItemIndex + 1).length || this.scrollerWidth <= this.visibleWidth)
                    this.$right.addClass("is-disabled");
                else if (this.$right.hasClass("is-disabled"))
                    this.$right.removeClass("is-disabled");
            }
        },
        setEvents: function() {
            this.$left.on("click", $.proxy(this.toPrev, this));
            this.$right.on("click", $.proxy(this.toNext, this));
            if ('ontouchstart' in window || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
                var touchStart = 0,
                    touchEnd = 0,
                    currentItemWidth = this.$tabsContentBloc.width()*.5,
                    _this = this;

                this.$scroller.on("touchstart", function (e) {
                    touchStart = e.originalEvent.touches[0].pageX;
                }).on("touchmove", function (e) {
                    touchEnd = e.originalEvent.touches[0].pageX;
                    if (touchStart - currentItemWidth >= touchEnd) {
                        _this.$right.first().trigger("click");
                        touchStart = touchEnd;
                    } else if (touchStart + currentItemWidth <= touchEnd) {
                        _this.$left.first().trigger("click");
                        touchStart = touchEnd;                    }
                });

                this.$tabsContentBloc.on("touchstart", function (e) {
                    touchStart = e.originalEvent.touches[0].pageX;
                }).on("touchmove", function (e) {
                    touchEnd = e.originalEvent.touches[0].pageX;
                    if (touchStart - currentItemWidth >= touchEnd) {
                        _this.$right.first().trigger("click");
                        touchStart = touchEnd;
                    } else if (touchStart + currentItemWidth <= touchEnd) {
                        _this.$left.first().trigger("click");
                        touchStart = touchEnd;
                    }
                });
            }

            this.$tabs.on("click", $.proxy(function (e) {
                this.$tab = $(e.currentTarget);
                if (!this.xhr) {
                    clearTimeout(this.autoTimer);
                    var tabIndex = this.$tabs.index(this.$tab);
                    this.showContent(tabIndex);
                    if (window.history.pushState && this.$tab.children("a") && this.$tab.children("a").attr("href").length > 1) {
                        var scrollTop = 0;
                        if ($(window).scrollTop())
                            scrollTop = $(window).scrollTop();
                        window.history.pushState({tabIndex:tabIndex, scrollTop:scrollTop}, tabIndex, this.$tab.children("a").attr("href"));
                    }
                    this.toCenter();
                    this.setControllers();
                }
                e.preventDefault();
            }, this));
            $(window).on("popstate", $.proxy(function() {
                if (window.history.state) {
                    var datas = window.history.state;
                    this.$tab = this.$tabs.eq(datas.tabIndex);
                    this.showContent(datas.tabIndex);
                    $(window).scrollTop(datas.scrollTop);
                }
            }, this));

            $(window).on("keydown", $.proxy(function(e) {
                if (e.keyCode == 37) {
                    this.$left.first().trigger("click");
                } else if (e.keyCode == 39) {
                    this.$right.first().trigger("click");
                }
            }, this));
        },
        unsetEvents: function() {
            this.$left.off("click");
            this.$right.off("click");
            if ('ontouchstart' in window || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
                this.$scroller.off("touchstart").off("touchmove");
                this.$tabsContentBloc.off("touchstart").off("touchmove");
            }
            this.$tabs.off("click");
            $(window).off("popstate");
            $(window).off("keydown");
        },
        toNext: function(e) {
            if (!this.$right.hasClass("is-disabled")) {
                this.setActiveItem();
                if (this.settings.autoTab && this.$items.eq(this.activeItemIndex + 1).length) {
                    this.activeItemIndex++;
                    this.$items.eq(this.activeItemIndex).trigger("click");
                }



            }
            e.preventDefault();
        },
        toPrev: function(e) {
            if (!this.$left.hasClass("is-disabled")) {
                this.setActiveItem();
                if (this.settings.autoTab && this.$items.eq(this.activeItemIndex - 1).length) {
                    this.activeItemIndex--;
                    this.$items.eq(this.activeItemIndex).trigger("click");




                }
            }
            e.preventDefault();
        },
        toCenter: function() {
            this.setActiveItem();
            if (this.$activeItem.length) {
                var itemWidth = this.$items.first().width();
                var visibleItems = Math.floor(this.visibleWidth / itemWidth);
                var itemOffset = Math.round((visibleItems - 1) / 2);
                if (this.activeItemIndex > itemOffset) {
                    var offsetIndex = (this.activeItemIndex - itemOffset < this.maxItemIndex) ? this.activeItemIndex - itemOffset : this.maxItemIndex;
                    this.slideTo(offsetIndex);
                } else {
                    this.slideTo(0);
                }
            }
        },
        slideTo: function(newItemIndex) {
            var offsetLeft = (newItemIndex > 0) ? this.$items.eq(newItemIndex).position().left * -1: 0;
            this.$scroller.css({left:offsetLeft});
            this.currentItemIndex = newItemIndex;
            this.setControllers();
        },

        showContent: function(tabIndex) {
            if (!this.$tab.hasClass(this.settings.tabActiveClass)) {

                setTimeout(function(){
                this.analytics.printPage();
                if (typeof OBR != 'undefined') {
                    OBR.extern.refreshWidget(window.location.href);
                }
                //if (!$("html").hasClass("in-app")) lazyads = $(document).lazyads().data("plugin_lazyads");
                },1000);

                var prevTabIndex = this.$tabs.index(this.$tabs.filter("." + this.settings.tabActiveClass));
                this.$tabs.filter("." + this.settings.tabActiveClass).removeClass(this.settings.tabActiveClass);
                this.$tab.addClass(this.settings.tabActiveClass);
                var html = Mustache.render(this.tplDiapoFocus, {
                    src: this.$tab.data("focus-src"),
                    title:this.$tab.data("focus-title"),
                    description:this.$tab.data("focus-description"),
                    index:tabIndex + 1,
                    total:this.$tabs.length
                });
                if (prevTabIndex < tabIndex)
                    this.$tabsContent.filter("[data-tabs-eq='"+ prevTabIndex +"']").addClass("to-left");
                else
                    this.$tabsContent.filter("[data-tabs-eq='"+ prevTabIndex +"']").addClass("to-right");

                if (this.$tabsContent.filter("[data-tabs-eq='"+ tabIndex +"']").length) {
                    this.$tabsContent.filter("[data-tabs-eq='"+ tabIndex +"']").removeClass("to-left to-right");
                } else {
                    this.$tabsContentBloc.append(html);
                    this.$tabsContent = this.$element.find(this.settings.tabContentElements);
                    this.$tabsContent.last().attr("data-tabs-eq", tabIndex);

                    if (prevTabIndex < tabIndex)
                        this.$tabsContent.filter("[data-tabs-eq='"+ tabIndex +"']").addClass("to-right").show();
                    else
                        this.$tabsContent.filter("[data-tabs-eq='"+ tabIndex +"']").addClass("to-left").show();

                    this.$tabsContent.filter("[data-tabs-eq='"+ tabIndex +"']").find("img").on("load", $.proxy(function() {
                        this.$element.addClass("is-loaded");
                        this.$tabsContent.filter("[data-tabs-eq='"+ tabIndex +"']").removeClass("to-left to-right");
                    }, this));
                }
            }
        },
    });

    $.fn[ pluginName ] = function (options) {
        this.each(function() {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
        return this;
    };

})(jQuery, window, document);
